var React = require('react');

function IconDropdownArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow"},React.createElement("path",{"id":"Vector","d":"M4 10.5234L12 18.5234L20 10.5234","stroke":"#8E4AFF","strokeWidth":"2.66667","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconDropdownArrowInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = IconDropdownArrowInline;

IconDropdownArrowInline.default = IconDropdownArrowInline;
